import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var agentAwardPill = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";background-color:", colors.warning.trim.default, ";");